import { Link, useLocation } from "react-router";
import { useTranslations } from "use-intl";
import { BarChart3, Dumbbell, Home, ListChecks, User } from "lucide-react";
import { cn } from "@/lib/utils";

const items = [
  { href: "/dashboard", key: "home", icon: Home },
  { href: "/plans", key: "plans", icon: ListChecks },
  { href: "/exercises", key: "exercises", icon: Dumbbell },
  { href: "/progress", key: "progress", icon: BarChart3 },
  { href: "/profile", key: "profile", icon: User },
] as const;

export function BottomNav() {
  const { pathname } = useLocation();
  const t = useTranslations("nav");
  return (
    <nav className="z-40 shrink-0 border-t bg-background/85 backdrop-blur-xl pb-safe">
      <ul className="mx-auto grid max-w-md grid-cols-5 px-2 pt-1.5">
        {items.map(({ href, key, icon: Icon }) => {
          const active = pathname === href || pathname.startsWith(href + "/");
          return (
            <li key={href}>
              <Link
                to={href}
                className={cn(
                  "flex flex-col items-center gap-0.5 rounded-xl py-1.5 text-[11px] font-medium transition-colors",
                  active ? "text-primary" : "text-muted-foreground hover:text-foreground",
                )}
              >
                <span
                  className={cn(
                    "flex h-7 w-12 items-center justify-center rounded-full transition-colors",
                    active && "bg-primary/15",
                  )}
                >
                  <Icon className="size-5" strokeWidth={active ? 2.4 : 2} />
                </span>
                {t(key)}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
